import { FC, ReactNode } from 'react'
import { Footer, Header } from '..'
import { StyledAppLayout } from '.'

type Props = {
  children: ReactNode
}

const AppLayout: FC<Props> = ({ children }) => {
  return (
    <StyledAppLayout $inPlatform={window.self !== window.top}>
      <Header />
      {children}
      <Footer />
    </StyledAppLayout>
  )
}

export default AppLayout
